// Title-string parsing extracted from the title1 / title2 / title /
// titleSegment0 / titleSegment2 / entityNameCapitalized computeds of
// components/defaultLayout/EntityDialog&Forms/EntityMaskForm.vue. Pulled into a
// pure module (computes all segments in one pass) so this delimiter parsing is
// unit-tested and survives the Nuxt 2 -> Nuxt 3 migration; the component's
// computeds now read off the returned object.
//
// entityNameTitleOverride encodes an optional two-line title split on '<br/>'
// and an optional three-part title split on '^^^' (segment0 ^^^ title ^^^ segment2).

export interface IParsedEntityMaskTitle {
  title1: string | null | undefined
  title2: string | undefined
  title: string
  titleSegment0: string
  titleSegment2: string
  entityNameCapitalized: string
}

export function parseEntityMaskTitle(
  entityNameTitleOverride: string | null | undefined,
  entityName: string | null | undefined
): IParsedEntityMaskTitle {
  const title1 = entityNameTitleOverride?.includes('<br/>')
    ? entityNameTitleOverride.split('<br/>')[0]
    : entityNameTitleOverride
  const title2 = entityNameTitleOverride?.includes('<br/>')
    ? entityNameTitleOverride.split('<br/>')[1]
    : undefined

  const entityNameCapitalized = entityName
    ? entityName.charAt(0).toUpperCase() + entityName.slice(1)
    : ''

  let title: string
  if (title1 && title1.includes('^^^')) {
    title = title1.split('^^^')[1]
  } else if (title1) {
    title = title1
  } else {
    title = entityNameCapitalized
  }

  const segments = entityNameTitleOverride?.includes('^^^')
    ? entityNameTitleOverride.split('^^^')
    : null
  const titleSegment0 = segments ? segments[0] : ''
  const titleSegment2 = segments ? segments[2] : ''

  return {
    title1,
    title2,
    title,
    titleSegment0,
    titleSegment2,
    entityNameCapitalized,
  }
}
